// Maeve-First tap-target card. Thin wrapper over the canonical `NavCard`
// (see Card.tsx) so the entry-screen cards and every other nav card share
// one implementation. Retained as a named export because callers across
// the Maeve-First surfaces import `ActionCard` directly.
//
// Copy rule (DESIGN §1.4 #8, §6.2.1): subtitles describe the destination,
// not Maeve's intent. Card content is composed by callers.

import type { ReactNode } from 'react';
import { NavCard } from '@/components/ui/Card.tsx';

interface ActionCardProps {
  to: string;
  title: string;
  subtitle: string;
  icon?: ReactNode;
}

export function ActionCard({ to, title, subtitle, icon }: ActionCardProps) {
  return <NavCard to={to} title={title} subtitle={subtitle} icon={icon} />;
}
